/** Наборы журнала узла, которыми владеет модуль заметок */
export enum EnumNoteSet {
  NOTES = 'note.notes',
  TABS = 'note.tabs',
}
